export enum UserManagementRolesGroup {
  UserManagementAdmin = 'UserManagementAdmin',
  /** The old, misspelled name. Accepted until UserMaster.API scripts/rename-user-management-admin.js has run in every environment; then remove. */
  UserManagamentAdminLegacy = 'UserManagamentAdmin',
}

/** The user admin role under either name during the rename. Route and menu roles match any of them. */
export const USER_MANAGEMENT_ADMIN_ROLES = [
  UserManagementRolesGroup.UserManagementAdmin,
  UserManagementRolesGroup.UserManagamentAdminLegacy,
];

/** E-signature pages, still in preview: only holders of this role see them, and never in prod (environment.features.signature). */
export enum SignatureRoles {
  SignaturePreview = 'SignaturePreview',
}

/** UserMaster.API approval-policy roles (#5772): Viewer reads, Admin also creates and edits. */
export enum ApprovalPolicyRoles {
  ApprovalPolicyViewer = 'ApprovalPolicyViewer',
  ApprovalPolicyAdmin = 'ApprovalPolicyAdmin',
}
